import * as firstRunBuilder from "common/first-run-builder";
import { getLocationSettings } from "../../../lib/location";

export function isFirstRunBuilderTemplate(templateID: string): boolean {
    const locationSettings = getLocationSettings();
    return firstRunBuilder.isFirstRunTemplate(templateID, locationSettings.useProductionTemplateIDs);
}

export function isPrivateProTrialTemplate(templateID: string): boolean {
    const locationSettings = getLocationSettings();
    const templateIsPrivateProTrial = firstRunBuilder.isPrivateProTrialTemplate(
        templateID,
        locationSettings.useProductionTemplateIDs
    );
    return templateIsPrivateProTrial;
}
